<div class="flex flex-row justify-end sm:hidden">
  <div class="-mt-4 -mr-4">
    <button mat-icon-button matDialogClose>
      <mat-icon class="icon-20">
        close
      </mat-icon>
    </button>
  </div>
</div>

<div class="md:pt-6 md:px-6">
  <div class="flex flex-row justify-between items-center mb-8">
    <div class="flex flex-col">
      <div class="mb-2 text-lg font-bold text-center md:mb-4 md:text-xxl sm:text-left">
        Wybierz swój bank
      </div>
      <div class="text-center text-gray-800 sm:text-left">
        Wybierz metodę płatności i potwierdź wybór przyciskiem. Przekierujemy Cię na stronę wybranego banku.
      </div>
    </div>

    <div class="hidden flex-none sm:block">
      <img
        class="w-32"
        [src]="'assets/img/fast_transfer_' + CURRENT_THEME_HOLDER.currentTheme + '_lg.svg'"
        alt="Szybki przelew"
      />
    </div>
  </div>

  <ng-container *ngIf="!error; else errorTemplate">
    <ng-container *ngIf="activeBanks$ | async as tiles; else skeletonTemplate">
      <form class="flex flex-col items-center webkit-scroll-touch" [formGroup]="form" (submit)="submit()">
        <div class="grid grid-cols-3 gap-2 w-full sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
          <ng-container *ngFor="let tile of tiles">
            <div class="flex flex-col rounded-lg aspect-w-16 aspect-h-9" (click)="select(tile)">
              <div class="flex flex-col">
                <div
                  class="items-stretch tile"
                  [class.active]="form.methodCode.value === tile.code"
                  [class.disabled]="!tile.isOnline"
                  [matTooltip]="tile.description + (tile.isOnline ? '' : ' (czasowo niedostępne)')"
                  matTooltipTouchGestures="off"
                  tabindex="0"
                >
                  <div class="flex relative flex-grow">
                    <img
                      [src]="images[tile.code]"
                      [alt]="tile.code"
                      class="object-contain absolute inset-0 w-full max-w-full h-full max-h-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="flex flex-col mt-8 items-center">
          <app-submit-button [ready]="!!form.methodCode.value" [loading]="submitted">
            Płacę szybkim przelewem
          </app-submit-button>

          <div class="mt-2">
            <button mat-button matDialogClose>
              <span class="text-gray-800">Zmień metodę płatności</span>
            </button>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-template #skeletonTemplate>
      <div class="grid grid-cols-3 gap-2 w-full sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
        <div *ngFor="let tile of skeletonTiles" class="bg-gray-200 rounded aspect-w-16 aspect-h-9"></div>
      </div>

      <div class="flex flex-col items-center">
        <div class="mt-8 w-56 h-10 bg-gray-200 rounded-lg"></div>
        <div class="mt-6 mb-4 w-40 h-4 bg-gray-200 rounded"></div>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #errorTemplate>
    <div class="flex flex-col items-center mt-16">
      <img class="w-20" src="assets/img/error.svg" alt="Błąd" />

      <div class="mt-6 font-semibold text-gray-850">Coś poszło nie tak</div>

      <div class="mt-4 text-sm text-center text-gray-850">
        Nie udało się pobrać listy banków. Spróbuj ponownie klikając w poniższy przycisk lub zmień metodę płatności.
        Jeśli problem się powtarza, napisz do nas.
      </div>

      <div class="flex flex-col items-center mt-12">
        <button type="button" mat-flat-button color="primary" (click)="retry()">
          Spróbuj ponownie
        </button>

        <div class="mt-2">
          <button mat-button matDialogClose>
            <span class="text-gray-800">Zmień metodę płatności</span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
